import React, { useContext, useState, useRef, useEffect } from 'react'
import axios from 'axios'
import { AuthContext } from '../context/AuthContext'
import { useNavigate, Link, useSearchParams } from 'react-router-dom'
import '../styles/SignIn.css'
import config from '../config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import useResponsiveWidth from '../hooks/useResponsiveWidth'
import OtpInputGroup from './OtpInputGroup';

// Example default PFPs
import defaultPfpOption1 from '../assets/defaultPfpOption1.png'
import defaultPfpOption2 from '../assets/defaultPfpOption2.png'
import defaultPfpOption3 from '../assets/defaultPfpOption3.png'

import { useSignUp, useSignIn, useAuth, useUser } from '@clerk/clerk-react';

const SignIn = () => {
  useResponsiveWidth()

  const { signUp } = useSignUp();
  const { signIn: clerkSignIn } = useSignIn();
  const { signOut: clerkSignOut } = useAuth();
  const [searchParams] = useSearchParams();
  const country = searchParams.get('c');
  const countryCode = (country == 'in') ? '+91' : '+1';
  const { user: clerkUser } = useUser();
  useEffect(() => {
    if (clerkUser) {
      // console.log('clerkUser: ',clerkUser);
    }
  }, [])

  const { signIn } = useContext(AuthContext)
  const navigate = useNavigate()

  // "view" can be: 'createAccount', 'createPin', 'createPfp', 'signIn', 'enterPin'
  const [view, setView] = useState('createAccount')

  // Basic account creation fields
  const [email, setEmail] = useState('')
  const [username, setUsername] = useState('')
  const [phone, setPhone] = useState('')
  const [name, setName] = useState('')
  const [isAccountCreating, setIsAccountCreating] = useState(false)

  // 12 digits = 6 + 6 for verify
  const [otpCode, setOtpCode] = useState(Array(12).fill(''))
  const otpCodeRefs = useRef([])

  const [signupToken, setSignupToken] = useState('')
  const [userOtp, setUserOtp] = useState(Array(6).fill(''))
  const userOtpRefs = useRef([])


  // Terms checkboxes
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [financialDisclaimerAccepted, setFinancialDisclaimerAccepted] =
    useState(false)

  // After user is created, store them + token
  const [newUserAccount, setNewUserAccount] = useState(null)

  // For the createPfp step:
  const defaultPfps = [
    { src: defaultPfpOption1, filename: 'defaultPfpOption1.png' },
    { src: defaultPfpOption2, filename: 'defaultPfpOption2.png' },
    { src: defaultPfpOption3, filename: 'defaultPfpOption3.png' },
  ]
  const [selectedPfpFilename, setSelectedPfpFilename] = useState(null)
  const [selectedPfpFile, setSelectedPfpFile] = useState(null)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [isMobileView, setIsMobileView] = useState(false)
  const { visibleSection, handleSwitchSection } = useContext(AuthContext)
  const [activeTab, setActiveTab] = useState(visibleSection)
  // We'll store a "File" object here once we've fetched the blob

  // ---------- RENDERING THE VIEWS ----------
  const renderView = () => {
    return (
      <div className="si-auth-content">
        {/* Buttons for Sign in vs. Create account */}
        {isMobile ? (
          !isMobileView && (
            <div className="si-mobile-buttons">
              <button
                className={`CreatePostFeedButton bold ${view === 'signIn' ? 'greenButton' : ''
                  }`}
                onClick={() => {
                  setView('signIn')
                  setIsMobileView(true)
                }}
              >
                Sign in
              </button>
              <button
                className={`CreatePostFeedButton bold ${view === 'createAccount' ? 'greenButton' : ''
                  }`}
                onClick={() => {
                  setView('createAccount')
                  setIsMobileView(true)
                }}
              >
                Create account
              </button>
            </div>
          )
        ) : (
          <div className="SignNavItems">
            <button
              className={`SignNavButton bold ${view === 'signIn' || view === 'enterPin'
                ? 'SignNavButtonActive'
                : ''
                }`}
              onClick={() => setView('signIn')}
            >
              <span className="si-btn-txt bold">Sign in</span>
            </button>
            <button
              className={`SignNavButton bold ${view === 'createAccount' ||
                view === 'createPin' ||
                view === 'createPfp'
                ? 'SignNavButtonActive'
                : ''
                }`}
              onClick={() => setView('createAccount')}
            >
              <span className="si-btn-txt bold">Create account</span>
            </button>
          </div>
        )}
        {renderViewContent()}
      </div>
    )
  }

  const renderViewContent = () => {
    if (!isMobile) {
      if (view === 'createAccount') {
        return (
          <div className="si-auth-form-wrapper">
            <form className="si-auth-form" onSubmit={handleCreateAccountSubmit}>
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <input
                type="number"
                placeholder="Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <button
                type="submit"
                className="CreatePostFeedButton greenButton moreButtonPadding si-form-btn"
                disabled={isAccountCreating}
              >
                {isAccountCreating ? 'Creating...' : 'Create account'}
              </button>
            </form>
          </div>
        )
      }

      if (view === 'createPin') {
        return (
          <div className="si-auth-form-wrapper" style={{ marginTop: '3rem' }}>
            <div
              className="pv-BackToFeedContainer"
              style={{ marginBottom: '3rem' }}
            >
              <button
                onClick={() => {
                  setView('createAccount')
                }}
                className="pv-BackButton"
                style={{ padding: 0, fontSize: 'var(--font-med-xl)' }}
              >
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  style={{ color: 'var(--action-grey)' }}
                />{' '}
                <span style={{ color: 'var(--action-grey)' }}>Back</span>
              </button>
            </div>

            <form onSubmit={handleOtpCreate}>
              <span className="pin-header-label">Enter Phone OTP</span>
              <div className="pin-inputs">
                {Array(6).fill('').map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    className="pin-input"
                    value={userOtp[index] || ''}
                    onChange={(e) => handleUserOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={handlePaste}
                    ref={(el) => (userOtpRefs.current[index] = el)}
                  />
                ))}
              </div>
              {email && (
                <>
                  <span className="pin-header-label">Enter Email OTP</span>
                  <OtpInputGroup otpCode={emailOtpInp} setOtpCode={setEmailOtpInp} rowIndex={1} />
                </>
              )}
              {/* <span className="pin-header-label">
                Create 6-Digit Numeric PIN
              </span>
              <div className="pin-inputs">
                {Array(6)
                  .fill('')
                  .map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      className="pin-input"
                      readOnly
                      data-row="1"
                      value={otpCode[index] || ''}
                      onClick={() => otpCodeRefs.current[index].focus()}
                      onKeyDown={(e) => handleOtpCodeChange(e, index, 1)}
                      ref={(el) => (otpCodeRefs.current[index] = el)}
                    />
                  ))}
              </div>
              <span className="pin-header-label">Verify PIN</span>
              <div className="pin-inputs">
                {Array(6)
                  .fill('')
                  .map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      className="pin-input"
                      readOnly
                      data-row="2"
                      value={otpCode[index + 6] || ''}
                      onClick={() => otpCodeRefs.current[index + 6].focus()}
                      onKeyDown={(e) => handleOtpCodeChange(e, index + 6, 2)}
                      ref={(el) => (otpCodeRefs.current[index + 6] = el)}
                    />
                  ))}
              </div> */}

              {/* Terms */}
              <div className="terms-container-signup">
                <label className="terms-label">
                  <input
                    type="checkbox"
                    checked={termsAccepted}
                    onChange={(e) => setTermsAccepted(e.target.checked)}
                    required
                    className="checkbox-input"
                    style={{ margin: 0, width: 'auto' }}
                  />
                  <span>
                    I have read and agreed to the{' '}
                    <a
                      target="_blank"
                      href="/privacy"
                      className="si-link bold"
                      rel="noreferrer"
                    >
                      privacy policy
                    </a>{' '}
                    and
                    <a
                      target="_blank"
                      href="/terms"
                      className="si-link bold"
                      rel="noreferrer"
                    >
                      {' '}
                      terms of service
                    </a>
                    .
                  </span>
                </label>
              </div>

              {/* Disclaimer */}
              <div className="disclaimer-container-signup">
                <label className="disclaimer-label">
                  <input
                    type="checkbox"
                    checked={financialDisclaimerAccepted}
                    onChange={(e) =>
                      setFinancialDisclaimerAccepted(e.target.checked)
                    }
                    required
                    className="checkbox-input"
                    style={{ margin: 0, width: 'auto' }}
                  />
                  <span>
                    I understand that content on Vestr is not financial advice.
                    Vestr is a tool to inform me, not make decisions for me.
                  </span>
                </label>
              </div>

              <button
                type="submit"
                className="CreatePostFeedButton greenButton moreButtonPadding"
                style={{ marginTop: '3rem' }}
                disabled={isAccountCreating}
              >
                {isAccountCreating ? 'Finalizing...' : 'Finish'}
              </button>
            </form>
          </div>
        )
      }

      if (view === 'createPfp') {
        return (
          <div
            className="si-auth-form-wrapper createPfpContainer"
            style={{ marginTop: '3rem' }}
          >
            <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
              <h2 style={{ margin: 0 }}>Pick a profile picture</h2>
              <p
                style={{ marginTop: '0.5rem', fontSize: 'var(--font-med-xl)' }}
              >
                You can change your profile picture at any time.
              </p>
            </div>
            <div className="createPfpOptions">
              {defaultPfps.map((pfp, idx) => (
                <img
                  key={idx}
                  src={pfp.src}
                  alt={`default-pfp-${idx + 1}`}
                  className={`createPfpOption ${selectedPfpFilename === pfp.filename ? 'selected' : ''
                    }`}
                  onClick={() => handleSelectPfp(pfp)}
                />
              ))}
            </div>
            <button
              onClick={handlePfpSubmit}
              className="CreatePostFeedButton greenButton moreButtonPadding si-form-btn"
              style={{ marginTop: '2rem' }}
              disabled={!selectedPfpFile}
            >
              Save profile picture
            </button>
          </div>
        )
      }

      if (view === 'enterPin') {
        return (
          <div className="si-auth-form-wrapper" style={{ marginTop: '3rem' }}>
            <div
              className="pv-BackToFeedContainer"
              style={{ marginBottom: '3rem' }}
            >
              <button
                onClick={() => {
                  setView('signIn')
                }}
                className="pv-BackButton"
                style={{ padding: 0, fontSize: 'var(--font-med-xl)' }}
              >
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  style={{ color: 'var(--action-grey)' }}
                />{' '}
                <span style={{ color: 'var(--action-grey)' }}>Back</span>
              </button>
            </div>

            <form onSubmit={handleOtpSubmit}>
              {isPhoneOtpReq && (
                <>
                  <span className="pin-header-label">Enter Phone OTP</span>
                  <div className="pin-inputs">
                    <OtpInputGroup otpCode={phoneOtpInp} setOtpCode={setPhoneOtpInp} rowIndex={1} />
                  </div>
                </>
              )}
              {isEmailOptReq && (
                <>
                  <span className="pin-header-label">Enter Email OTP</span>
                  <div className="pin-inputs">
                    <OtpInputGroup otpCode={emailOtpInp} setOtpCode={setEmailOtpInp} rowIndex={2} />
                  </div>
                </>

              )}
              {isPasswordReq && (
                <>
                  <div className="si-auth-form pt-0">
                    <input
                      type="password"
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                </>
              )}

              {!isPasswordReq && !isEmailOptReq && !isPhoneOtpReq && (
                <>
                  <span className="pin-header-label">Enter PIN</span>
                  <div className="pin-inputs">
                    {Array(6)
                      .fill('')
                      .map((_, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength="1"
                          className="pin-input"
                          readOnly
                          data-row="1"
                          value={otpCode[index] || ''}
                          onClick={() => otpCodeRefs.current[index].focus()}
                          onKeyDown={(e) => handleOtpCodeChange(e, index, 1)}
                          ref={(el) => (otpCodeRefs.current[index] = el)}
                        />
                      ))}
                  </div>
                </>
              )}
              <button
                type="submit"
                className="CreatePostFeedButton greenButton moreButtonPadding si-form-btn"
                style={{ marginTop: '3rem' }}
                disabled={isAuthenticating}
              >
                {isAuthenticating ? 'Signing in...' : 'Sign in'}
              </button>
            </form>
          </div>
        )
      }

      if (view === 'signIn') {
        return (
          <div className="si-auth-form-wrapper">
            <form className="si-auth-form" onSubmit={handleLoginSubmit}>
              <input
                type="number"
                placeholder="Phone Number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              <button
                type="submit"
                className="CreatePostFeedButton greenButton moreButtonPadding si-form-btn"
                disabled={isAuthenticating}
              >
                {isAuthenticating ? 'Signing in...' : 'Sign in'}
              </button>
              <Link to="/forgot-pin" className="btn">
                Forgot your PIN?
              </Link>
            </form>
          </div>
        )
      }
    } else {
      if (isMobileView) {
        if (view === 'signIn' || view === 'enterPin') {
          return (
            <div className="si-auth-form-wrapper">
              <h2 className="si-form-header">Sign in</h2>


              <form className="si-auth-form" onSubmit={view === 'signIn' ? handleLoginSubmit : handleOtpSubmit}>


                <label htmlFor="phone">Phone Number</label>
                <input
                  type="text"
                  placeholder="Phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
                {/* <label htmlFor="pin">Enter PIN</label>
                <div className="pin-inputs">
                  {Array(6)
                    .fill('')
                    .map((_, index) => (
                      <input
                        key={index}
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="1"
                        className="pin-input"
                        value={otpCode[index] || ''}
                        onClick={() => otpCodeRefs.current[index].focus()}
                        onKeyDown={(e) =>
                          handleMobileOtpCodeChange(e, index, 1)
                        }
                        ref={(el) => (otpCodeRefs.current[index] = el)}
                      />
                    ))}
                </div> */}
                {isPhoneOtpReq && (
                  <>
                    <span className="pin-header-label">Enter Phone OTP</span>
                    <div className="pin-inputs">
                      <OtpInputGroup otpCode={phoneOtpInp} setOtpCode={setPhoneOtpInp} rowIndex={1} />
                    </div>
                  </>
                )}
                {isPasswordReq && (
                  <>
                    <span className="pin-header-label">Enter Password</span>
                    <div className="pin-inputs">
                      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                  </>
                )}
                {!isPasswordReq && !isPhoneOtpReq && !isEmailOptReq && view == 'enterPin' && (
                  <>
                    <span className="pin-header-label">Enter PIN</span>
                    <div className="pin-inputs">
                      {Array(6)
                        .fill('')
                        .map((_, index) => (
                          <input
                            key={index}
                            type="text"
                            maxLength="1"
                            className="pin-input"
                            readOnly
                            data-row="1"
                            value={otpCode[index] || ''}
                            onClick={() => otpCodeRefs.current[index].focus()}
                            onKeyDown={(e) => handleOtpCodeChange(e, index, 1)}
                            ref={(el) => (otpCodeRefs.current[index] = el)}
                          />
                        ))}
                    </div>
                  </>
                )}

                <a href="#" className="forgot-pin-link">
                  Forgot PIN?
                </a>
                <div className="si-mobile-buttons">
                  <button
                    type="submit"
                    className="CreatePostFeedButton greenButton"
                  >
                    Sign in
                  </button>
                  <button
                    type="button"
                    className="CreatePostFeedButton outlineButton"
                    onClick={() => setView('createAccount')}
                  >
                    Create account
                  </button>
                </div>
              </form>
            </div>
          )
        }

        if (view === 'createPin') {
          return (
            <div className="si-auth-form-wrapper" style={{ marginTop: '3rem' }}>
              <h2 className="si-form-header">Step 2 / 3</h2>
              {renderProgressBar(2)}
              <form className="si-auth-form" onSubmit={handleOtpCreate}>
                <span className="pin-header-label">
                  Create 6-Digit Numeric PIN
                </span>
                <div className="pin-inputs">
                  {Array(6)
                    .fill('')
                    .map((_, index) => (
                      <input
                        key={index}
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="1"
                        className="pin-input"
                        value={otpCode[index] || ''}
                        onClick={() => otpCodeRefs.current[index].focus()}
                        onKeyDown={(e) =>
                          handleMobileOtpCodeChange(e, index, 1)
                        }
                        ref={(el) => (otpCodeRefs.current[index] = el)}
                      />
                    ))}
                </div>
                <span className="pin-header-label">Verify PIN</span>
                <div className="pin-inputs">
                  {Array(6)
                    .fill('')
                    .map((_, index) => (
                      <input
                        key={index}
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="1"
                        className="pin-input"
                        value={otpCode[index + 6] || ''}
                        onClick={() => otpCodeRefs.current[index + 6].focus()}
                        onKeyDown={(e) =>
                          handleMobileOtpCodeChange(e, index + 6, 2)
                        }
                        ref={(el) => (otpCodeRefs.current[index + 6] = el)}
                      />
                    ))}
                </div>

                {/* Terms */}
                <div className="terms-container-signup">
                  <label className="terms-label">
                    <input
                      type="checkbox"
                      checked={termsAccepted}
                      onChange={(e) => setTermsAccepted(e.target.checked)}
                      required
                      className="checkbox-input"
                      style={{ margin: 0, width: 'auto' }}
                    />
                    <span>
                      I have read and agreed to the{' '}
                      <a
                        target="_blank"
                        href="/privacy"
                        className="si-link bold"
                        rel="noreferrer"
                      >
                        privacy policy
                      </a>{' '}
                      and
                      <a
                        target="_blank"
                        href="/terms"
                        className="si-link bold"
                        rel="noreferrer"
                      >
                        {' '}
                        terms of service
                      </a>
                      .
                    </span>
                  </label>
                </div>

                {/* Disclaimer */}
                <div className="disclaimer-container-signup">
                  <label className="disclaimer-label">
                    <input
                      type="checkbox"
                      checked={financialDisclaimerAccepted}
                      onChange={(e) =>
                        setFinancialDisclaimerAccepted(e.target.checked)
                      }
                      required
                      className="checkbox-input"
                      style={{ margin: 0, width: 'auto' }}
                    />
                    <span>
                      I understand that content on Vestr is not financial
                      advice. Vestr is a tool to inform me, not make decisions
                      for me.
                    </span>
                  </label>
                </div>
                <div className="si-mobile-buttons">
                  <button
                    type="submit"
                    className="CreatePostFeedButton greenButton"
                  >
                    Next
                  </button>
                  <button
                    onClick={() => {
                      setView('createAccount')
                    }}
                    className="CreatePostFeedButton outlineButton pv-BackButton"
                    style={{ padding: 0, fontSize: 'var(--font-med-xl)' }}
                  >
                    Back
                  </button>
                </div>
              </form>
            </div>
          )
        }
        if (view === 'createPfp') {
          return (
            <div
              className="si-auth-form-wrapper createPfpContainer"
              style={{ marginTop: '3rem' }}
            >
              <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
                <h2 style={{ margin: 0 }}>Pick a profile picture</h2>
                <p
                  style={{
                    marginTop: '0.5rem',
                    fontSize: 'var(--font-med-xl)',
                  }}
                >
                  You can change your profile picture at any time.
                </p>
              </div>
              <div className="createPfpOptions">
                {defaultPfps.map((pfp, idx) => (
                  <img
                    key={idx}
                    src={pfp.src}
                    alt={`default-pfp-${idx + 1}`}
                    className={`createPfpOption ${selectedPfpFilename === pfp.filename ? 'selected' : ''
                      }`}
                    onClick={() => handleSelectPfp(pfp)}
                  />
                ))}
              </div>
              <button
                onClick={handlePfpSubmit}
                className="CreatePostFeedButton greenButton moreButtonPadding si-form-btn"
                style={{ marginTop: '2rem' }}
                disabled={!selectedPfpFile}
              >
                Save profile picture
              </button>
            </div>
          )
        }


        if (view === 'createAccount') {
          return (
            <div className="si-auth-form-wrapper">
              <h2 className="si-form-header">Step 1 / 3</h2>
              {renderProgressBar(1)}
              <form
                className="si-auth-form"
                onSubmit={handleCreateAccountSubmit}
              >
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
                <label htmlFor="email">
                  Email (must use school email to participate in school
                  competitions)
                </label>
                <input
                  type="email"
                  placeholder="Email (must use school email)"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <label htmlFor="phone">Phone number</label>
                <input
                  type="text"
                  placeholder="Phone number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
                <div className="si-mobile-buttons">
                  <button
                    type="submit"
                    className="CreatePostFeedButton greenButton"
                  >
                    Next
                  </button>
                  <button
                    type="button"
                    className="CreatePostFeedButton outlineButton"
                    onClick={() => setView('signIn')}
                  >
                    Back
                  </button>
                </div>
              </form>
            </div>
          )
        }
      }
    }

    return null
  }

  const handleTabSwitch = (tab) => {
    setActiveTab(tab)
    handleSwitchSection(tab)
  }

  const renderProgressBar = (currentStep) => {
    const steps = [1, 2, 3]
    const progressWidth = `${(currentStep / steps.length) * 100}%`

    return (
      <div className="progress-bar">
        <div
          className="progress-bar-filled"
          style={{ width: progressWidth }}
        ></div>
      </div>
    )
  }

  const handleMobileOtpCodeChange = (e, index, rowIndex) => {
    let value = e.target.value || e.key

    // Ensure only digits (ignore non-numeric inputs)
    if (!/^\d$/.test(value) && value !== '' && e.key !== 'Backspace') return

    const newOtpCode = [...otpCode]

    // Handle backspace/delete properly
    if (e.key === 'Backspace' || value === '') {
      newOtpCode[index] = '' // Clear the current input
      setOtpCode(newOtpCode)

      if (index > 0) {
        otpCodeRefs.current[index - 1]?.focus() // Move back if not the first input
      }
      return
    }

    newOtpCode[index] = value
    setOtpCode(newOtpCode)

    const isLastInRow = rowIndex === 1 ? 5 : 11

    // Move focus to the next input field (Web & Mobile)
    if (value !== '' && index < isLastInRow) {
      otpCodeRefs.current[index + 1]?.focus()
    }
  }

  // ---------- HANDLERS ----------
  const handleOtpCodeChange = (e, index, rowIndex) => {
    const newOtpCode = [...otpCode]
    const isLastInRow = rowIndex === 1 ? 5 : 11

    if (/^[0-9]$/.test(e.key)) {
      newOtpCode[index] = e.key
      setOtpCode(newOtpCode)

      if (
        index < isLastInRow &&
        otpCodeRefs.current[index + 1].dataset.row === `${rowIndex}`
      ) {
        otpCodeRefs.current[index + 1].focus()
      }
    } else if (e.key === 'Backspace') {
      if (newOtpCode[index]) {
        newOtpCode[index] = ''
      } else if (index > 0) {
        otpCodeRefs.current[index - 1].focus()
        newOtpCode[index - 1] = ''
      }
      setOtpCode(newOtpCode)
    } else if (
      e.key === 'ArrowLeft' &&
      index > 0 &&
      otpCodeRefs.current[index - 1].dataset.row === `${rowIndex}`
    ) {
      otpCodeRefs.current[index - 1].focus()
    } else if (
      e.key === 'ArrowRight' &&
      index < isLastInRow &&
      otpCodeRefs.current[index + 1].dataset.row === `${rowIndex}`
    ) {
      otpCodeRefs.current[index + 1].focus()
    }
  }
  const handleUserOtpChangeBK = (e, index, rowIndex) => {
    const newOtpCode = [...otpCode]
    const isLastInRow = rowIndex === 1 ? 5 : 11

    if (/^[0-9]$/.test(e.key)) {
      newOtpCode[index] = e.key
      setUserOtp(newOtpCode)

      if (
        index < isLastInRow &&
        userOtpRefs.current[index + 1].dataset.row === `${rowIndex}`
      ) {
        userOtpRefs.current[index + 1].focus()
      }
    } else if (e.key === 'Backspace') {
      if (newOtpCode[index]) {
        newOtpCode[index] = ''
      } else if (index > 0) {
        userOtpRefs.current[index - 1].focus()
        newOtpCode[index - 1] = ''
      }
      setUserOtp(newOtpCode)
    } else if (
      e.key === 'ArrowLeft' &&
      index > 0 &&
      userOtpRefs.current[index - 1].dataset.row === `${rowIndex}`
    ) {
      userOtpRefs.current[index - 1].focus()
    } else if (
      e.key === 'ArrowRight' &&
      index < isLastInRow &&
      userOtpRefs.current[index + 1].dataset.row === `${rowIndex}`
    ) {
      userOtpRefs.current[index + 1].focus()
    }
  }
  const handleUserOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value)) {
      const newOtp = [...userOtp];
      newOtp[index] = value;
      setUserOtp(newOtp);

      // Move to next input
      if (index < 5) {
        userOtpRefs.current[index + 1]?.focus();
      }
    } else if (value === '') {
      const newOtp = [...userOtp];
      newOtp[index] = '';
      setUserOtp(newOtp);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (userOtp[index]) {
        const newOtp = [...userOtp];
        newOtp[index] = '';
        setUserOtp(newOtp);
      } else if (index > 0) {
        userOtpRefs.current[index - 1]?.focus();
      }
    } else if (e.key === 'ArrowLeft' && index > 0) {
      userOtpRefs.current[index - 1]?.focus();
    } else if (e.key === 'ArrowRight' && index < 5) {
      userOtpRefs.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData('Text').trim().slice(0, 6);
    if (/^[0-9]+$/.test(pastedData)) {
      const newOtp = pastedData.split('');
      setUserOtp(newOtp);
      newOtp.forEach((char, idx) => {
        if (userOtpRefs.current[idx]) {
          userOtpRefs.current[idx].value = char;
        }
      });
      if (userOtpRefs.current[pastedData.length - 1]) {
        userOtpRefs.current[pastedData.length - 1].focus();
      }
    }
  };

  // const [phoneNumberId, setPhoneNumberId] = useState('');
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [isPhoneOtpReq, setIsPhoneOtpReq] = useState(false);
  const [isEmailOptReq, setIsEmailOptReq] = useState(false);
  const [isPasswordReq, setIsPasswordReq] = useState(false);
  const [password, setPassword] = useState('');

  const [emailOtpInp, setEmailOtpInp] = useState('');
  const [phoneOtpInp, setPhoneOtpInp] = useState('');


  const handleLoginSubmit = async (e) => {
    e.preventDefault()
    setIsAuthenticating(true);
    // await clerkSignOut();return;
    try {
      var phoneNumber = `${countryCode}${phone}`;
      const response = await axios.post(
        `${config.backendUrl}/api/auth/signin`,
        {
          phone,
        }
      );
      if (response.status === 200) {
        var resData = response.data;
        if (resData.data.isPhoneOtpReq) {
          const phonesignInAttempt = await clerkSignIn.create({ identifier: phoneNumber, strategy: 'phone_code' });
          setIsPhoneOtpReq(true)
        }
        if (resData.data.isEmailOtpReq) {
          // const emailsignInAttempt = await clerkSignIn.create({ identifier: resData.data.email, strategy: 'email_link' });
          // setIsEmailOptReq(true)
        }
        if (resData.data.isPasswordReq) {
          setIsPasswordReq(true)
        }


      }
      // console.log(signInAttempt);
      // const factor = signInAttempt.supportedFirstFactors.find(
      //   (f) => f.strategy === 'phone_code' && f.phoneNumber === phoneNumber
      // );

      // if (!factor) throw new Error('Phone number not found for OTP');

      // setPhoneNumberId(factor.phoneNumberId);

      // await clerkSignIn.prepareFirstFactor({
      //   strategy: 'phone_code',
      //   phoneNumberId: factor.phoneNumberId,
      //   phoneNumber
      // });
      // await clerkSignIn.create({ identifier: phoneNumber });
      // await clerkSignIn.prepareFirstFactor({ strategy: 'phone_code', phoneNumber: phoneNumber });
      setView('enterPin')
      /* const response = await axios.post(
        `${config.backendUrl}/api/auth/signin`,
        {
          phone,
        }
      )
      if (response.status === 200) {
        setView('enterPin')
      } */

    } catch (error) {
      console.error(error)
      if (error && error.errors && error?.errors[0]?.message) {
        alert('Error signing in ' + JSON.stringify(error.errors[0].message))
      }
      else {
        alert('Error signing in ' + error)
      }
    } finally {
      setIsAuthenticating(false);
    }
  }

  const handleMobileLoginSubmit = async (e) => {
    e.preventDefault()
    try {
      const response = await axios.post(
        `${config.backendUrl}/api/auth/signin`,
        {
          phone,
        }
      )
      if (response.status === 200) {
        e.preventDefault()
        try {
          const response = await axios.post(
            `${config.backendUrl}/api/auth/verify-otp`,
            {
              phone,
              otp: otpCode.join(''),
            }
          )
          if (response.status === 200) {
            signIn(response.data.user)
            handleTabSwitch('posts')
            navigate('/feed')
          }
        } catch (error) {
          alert(error.response.data)
        }
      }
    } catch (error) {
      console.error(error)
      alert('Error signing in')
    }
  }

  const handleCreateAccountSubmit = async (e) => {
    e.preventDefault()
    try {
      setIsAccountCreating(true)
      const response = await axios.post(
        `${config.backendUrl}/api/auth/signup`,
        {
          email,
          username,
          phone,
          name,
          password
        }
      )
      if (response.status === 200) {
        await signUp.create({
          emailAddress: email,
          phoneNumber: `${countryCode}${phone}`,
          username,
          password
        });
        await signUp.preparePhoneNumberVerification();
        if (email) {
          await signUp.prepareEmailAddressVerification({ strategy: 'email_code' });
        }
        setView('createPin')
      }
      else {
        throw new Error("try again");
      }
      /* 
        setView('createPin')
        setSignupToken(response.data.token)
      } */
    } catch (error) {
      // alert(error.response.data)
      if (error.errors) {
        alert(error.errors[0].message)
      }
      else if (error.response.data) {
        alert(error.response.data)
      }
      else {
        alert(error)
      }
      // console.log('error: ', error);
    } finally {
      setIsAccountCreating(false)
    }
  }

  const handleOtpCreate = async (e) => {
    e.preventDefault()
    var received = userOtp;
    received = received.join('');
    setIsAccountCreating(true)
    try {
      var emailOtpInpRec = emailOtpInp;
      emailOtpInpRec = emailOtpInpRec.join('');
      const emailVerificationResult = await signUp.attemptEmailAddressVerification({ code: emailOtpInpRec });
      const result = await signUp.attemptPhoneNumberVerification({ code: received });
      var isOk = false;
      if (emailVerificationResult.status == 'complete') {
        isOk = true;
      }
      else {
        alert("Invalid Email OTP")
      }
      if (result.status == 'complete') {
        isOk = true;
      }
      else {
        alert("Invalid Phone OTP")
      }

      if (isOk) {
        const otp = otpCode.join('')
        const response = await axios.post(
          `${config.backendUrl}/api/auth/create-otp`,
          {
            otp: otp.slice(0, 6),
            email,
            username,
            phone,
            name,
            password,
            country
            // code: received,
            // token: signupToken
          }
        )
        if (response.status === 200) {
          setNewUserAccount(response.data.user)
          setView('createPfp')
        }
      }
      else {
        alert("Invalid OTP");
      }
    } catch (error) {
      alert(JSON.stringify(error));
      alert("Invalid OTP");
    } finally {
      setIsAccountCreating(false)
    }
    /* if (!termsAccepted || !financialDisclaimerAccepted) {
      alert('Please accept the terms and disclaimer')
      return
    }
    const otp = otpCode.join('')
    if (otp.length !== 12 || otp.slice(0, 6) !== otp.slice(6, 12)) {
      alert(
        'Invalid PIN. Make sure the PIN is 6 digits and matches the verification PIN.'
      )
      return
    }

    try {
      const response = await axios.post(
        `${config.backendUrl}/api/auth/create-otp`,
        {
          otp: otp.slice(0, 6),
          email,
          username,
          phone,
          name,
          code: userOtp,
          token: signupToken
        }
      )
      if (response.status === 200) {
        setNewUserAccount(response.data.user)
        setView('createPfp')
      }
    } catch (error) {
      console.error(error)
      alert('Error creating PIN')
    } */
  }

  // handle user entering PIN to sign in
  const handleOtpSubmit = async (e) => {
    e.preventDefault()
    try {
      var isOk = false;
      if (isPhoneOtpReq) {
        var receivedOtp = phoneOtpInp;
        receivedOtp = receivedOtp.join('');

        if (receivedOtp) {
          var result = await clerkSignIn.attemptFirstFactor({ strategy: 'phone_code', code: receivedOtp });
          if (result.status === 'complete') {
            isOk = true;
          }
        }
        else {
          alert('Please enter OTP'); return;
        }
      }
      if (isEmailOptReq) {
        var receivedOtp = emailOtpInp;
        receivedOtp = receivedOtp.join('');
        receivedOtp = receivedOtp.slice(0, 6);
        if (receivedOtp) {
          var result = await clerkSignIn.attemptFirstFactor({ strategy: 'email_code', code: receivedOtp });
          if (result.status === 'complete') {
            isOk = true;
          }
        }
        else {
          alert('Please enter OTP'); return;
        }
      }
      if (isPasswordReq && password) {
        isOk = true;
      }
      else if (isPasswordReq && password == '') {
        alert('Please enter password'); return;
      }
      if (!isPhoneOtpReq && !isEmailOptReq && !isPasswordReq) {
        isOk = true;
      }
      if (isOk) {
        var otpCodeRec = otpCode;
        otpCodeRec = otpCodeRec.join('');
        const response = await axios.post(
          `${config.backendUrl}/api/auth/verify-otp`,
          {
            phone,
            otp: otpCode,
            password: password
          }
        )
        if (response.status === 200) {
          signIn(response.data.user)
          navigate('/')
        }
        else {
          alert('Error signing in. Please try again.')
        }
      }
    } catch (error) {
      console.log(error.response.data)
      if (error.response && error.response.data) {
        alert(error.response.data)
      }
      else if (error.errors) {
        alert(error.errors[0].message)
      }
      else if (error.message) {
        alert(error.message)
      }
      else {
        alert('Error signing in. Please try again.')
        console.error(error)
      }
    }
  }

  // When user clicks one of the 3 PFP images
  const handleSelectPfp = async (pfp) => {
    // We'll store just the filename in 'selectedPfpFilename'
    // then also fetch the local image as a blob => create a File
    try {
      const resp = await fetch(pfp.src)
      const blob = await resp.blob()
      const file = new File([blob], pfp.filename, { type: blob.type })

      setSelectedPfpFilename(pfp.filename)
      setSelectedPfpFile(file)
    } catch (err) {
      console.error('Error loading local image as file:', err)
      alert('Error loading image. Please try again.')
    }
  }

  // Submitting the selected PFP
  const handlePfpSubmit = async () => {
    if (!selectedPfpFile) {
      alert('Please select a profile picture')
      return
    }

    const token = newUserAccount?.token
    const userId = newUserAccount?.id
    if (!token || !userId) {
      alert('An error has occured. Please refresh the page and sign in.')
      return
    }

    try {
      // We'll do a multipart/form-data with FormData
      const formData = new FormData()
      formData.append('userId', userId)
      formData.append('username', username)
      formData.append('name', name)
      formData.append('bio', '')
      formData.append('social', '')
      // The server expects "profilePicture" for the key
      formData.append('profilePicture', selectedPfpFile)

      // Now do a PUT with axios
      await axios.put(`${config.backendUrl}/api/auth/edit-profile`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })

      // Done => signIn the user object we have or just navigate
      let userWithNewPfp = {
        ...newUserAccount,
        profilePicture: `profile-pictures/${selectedPfpFile.name}`,
      }
      signIn(userWithNewPfp)
      navigate('/feed')
    } catch (err) {
      console.error(err)
      alert('Error updating profile picture')
    }
  }

  return (
    <div className="signin-container">
      {!isMobile && (
        <>
          <h1 className="si-main-header">Invest with the best.</h1>
          <div className="si-main-content">
            <div className="si-intro-text">
              <h2>The Vestr Vision</h2>
              <p style={{ paddingTop: '3rem' }}>
                We envision a <b>finance super app</b> complete with
                leaderboards, live trading, sim trading, feed, news, rooms, copy
                trading, subscriptions, professional research, trading AI and
                more. We want to be the <b>home for the retail revolution</b>,
                where users can find experts and experts find their audience.
              </p>
              <p>
                Also check out{' '}
                <a
                  className="si-link bold"
                  href="https://vestrdata.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  vestrdata.com
                </a>
                !
              </p>
            </div>
            {renderView()}
          </div>
        </>
      )}
      {isMobile && !isMobileView && (
        <>
          <h1 className="si-main-header">Invest with the best.</h1>
          <div className="si-main-content">
            <div className="si-intro-text">
              <h2>Vestr is the all in one (simulated) finance platform</h2>
              <div style={{ paddingTop: '1rem' }}>
                <p>
                  1/ Follow your friends and top investors to see who is the
                  best (and worst)
                </p>{' '}
                <p>
                  2/ Trade stocks, options, and crypto (desktop only). Create
                  multiple portfolios to test different strategies!
                </p>
                <p>3/ Join leaderboards to see how you rank</p>
              </div>
            </div>
          </div>
        </>
      )}
      {isMobile && renderView()}
    </div>
  )
}

export default SignIn